class ProductCard extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.initialValue = this.labelValue

    this.querySelectorAll('img[srcset]').forEach(image => {
      // eslint-disable-next-line no-self-assign
      image.outerHTML = image.outerHTML
    })
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.handleTrigger.bind(this))

    this.listeners.add(this, 'focusin', this.handleTrigger.bind(this))
  }

  connectedCallback () {
    super.connectedCallback()

    const event = new CustomEvent('AFTER_PRODUCT_CARD_RENDER', {
      detail: {
        product: this,
      },
    })

    window.dispatchEvent(event)
  }

  handleTrigger (event) {
    const target = event?.target
    const currentTriggerEl = target.closest(this.els?.mediaTrigger?.selector)
    if (!currentTriggerEl) return

    this.setAttribute(
      'data-visible-media-index',
      currentTriggerEl.dataset?.mediaIndex,
    )
    this.els.mediaTrigger.elements.forEach(mediaTriggerEl =>
      mediaTriggerEl.setAttribute(
        this.currentAttribute,
        (mediaTriggerEl === currentTriggerEl).toString(),
      ),
    )
  }

  get currentAttribute () {
    return `aria-current`
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard)
}

class ProductCardQuickBuy extends window.BAO.ProductForm {
  constructor () {
    super()
    this.initialValue = this.labelValue
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.trackKlevuATC.bind(this))

    if (!this.selectEl || !this.buttonEl) return
    this.listeners.add(
      this.selectEl,
      'change',
      this.handleSelectChange.bind(this),
    )
  }

  handleSelectChange (event) {
    const selectEl = event?.target
    if (!selectEl) return
    const value = selectEl.value
    const disabled = !(value && value.length)
    this.buttonEl.disabled = disabled

    const optionEl = window.BAO.Utils.getElement(`[value="${value}"]`, {
      context: selectEl,
    })

    if (!optionEl) return

    const comparePrice = optionEl.dataset.comparePrice
    const price = optionEl.dataset.price

    const cardEl = this.closest('product-card')
    const comparePriceEl = cardEl.querySelector(
      '.prd-CardPrice_ComparePrice-money',
    )
    const priceEl = cardEl.querySelector('.prd-CardPrice_Price')

    this.labelValue = optionEl.textContent

    if (price) {
      priceEl.textContent = price
      priceEl.classList.toggle('prd-CardPrice_Price-sale', !!comparePrice)
      comparePriceEl.hidden = !comparePrice
    }

    if (comparePrice) {
      comparePriceEl.textContent = comparePrice
    }
  }

  trackKlevuATC (event) {
    if (!window.klevu) return

    if (this.closest('.kuCategoryPageContainer')) {
      this.trackKlevuCategoryClick()
    } else if (this.closest('.kuSearchResultsPageContainer')) {
      this.trackKlevuLandingClick()
    } else if (this.closest('.kuQuickResultsListContainer')) {
      this.trackKlevuQuickSearchClick()
    } else {
      this.trackKlevuClick()
    }
  }

  trackKlevuClick () {
    const data = JSON.stringify([
      {
        event: 'select_recs_list',
        event_apikey: window.klevu?.settings?.search?.apiKey,
        event_list_id: this.recommendationsListId,
        event_list_name: this.recommendationsTitle,
        event_list_logic: this.recommendationsLogic,
        items: [
          {
            item_id: this.variantId,
            item_group_id: this.productId,
            item_variant_id: this.variantId,
            item_name: this.title,
            price: this.productPrice,
            index: 1,
          },
        ],
      },
    ])

    fetch('https://stats.ksearchnet.com/analytics/collect', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    }).catch(error => {
      console.error('Error:', error)
    })
  }

  trackKlevuCategoryClick () {
    const klevuApiKey = window.klevu?.settings?.search?.apiKey
    const klevuResponse = window.klevu?.search?.catnav
      ?.getScope()
      ?.data?.response?.current?.queryResults?.filter(
        item => item.id === 'productList',
      )
    const klevuRequest = window.klevu?.search?.catnav
      ?.getScope()
      ?.data?.request?.current?.recordQueries?.filter(
        item => item.id === 'productList',
      )

    if (!klevuApiKey) return

    const klevuSrc = '[[typeOfRecord:KLEVU_PRODUCT;;template:category]]'
    const klevuLimit = window.klevu_productsInitialLimit || 24
    const klevuSort = klevuRequest[0].settings.sort || 'RELEVANCE'
    const klevuTotalResults = klevuResponse[0].meta.noOfResults || 0
    const klevuTypeOfQuery = klevuResponse[0].meta.typeOfSearch || 'AND'
    const klevuProductIds = encodeURIComponent(
      klevuResponse[0].records?.map(item => item.itemGroupId).join(',') || '',
    )
    const klevuSalePrice = this.productPrice
    const klevuProductSku = this.productSku

    const klevuProductRatings =
      klevuResponse[0].records
        ?.filter(item => item?.rating !== undefined)
        ?.map(item => item?.rating)
        .map(Number) || []
    const averageRating =
      klevuProductRatings.reduce((acc, rating) => acc + rating, 0) /
      klevuProductRatings.length

    const klevuCategoryName =
      window.klevu?.search?.catnav?.getScope().data?.context?.categoryPath || ''
    const klevuCategoryPath =
      window.klevu?.search?.catnav?.getScope().data?.context?.categoryPath || ''
    const klevuProductId = this.variantId
    const klevuProductGroupId = this.productId
    const klevuProductVariantId = this.variantId
    const klevuProductName = encodeURIComponent(this.title)
    const klevuProductUrl = encodeURIComponent(this.productUrl)

    const url = `https://stats.ksearchnet.com/analytics/categoryProductClickTracking?klevu_apiKey=${klevuApiKey}&klevu_categoryName=${klevuCategoryName}&klevu_categoryPath=${klevuCategoryPath}&klevu_productId=${klevuProductId}&klevu_productGroupId=${klevuProductGroupId}&klevu_productVariantId=${klevuProductVariantId}&klevu_productName=${klevuProductName}&klevu_productUrl=${klevuProductUrl}&klevu_src=${klevuSrc}&klevu_limit=${klevuLimit}&klevu_sort=${klevuSort}&klevu_totalResults=${klevuTotalResults}&klevu_typeOfQuery=${klevuTypeOfQuery}&klevu_productIds=${klevuProductIds}&klevu_salePrice=${klevuSalePrice}&klevu_productSku=${klevuProductSku}&klevu_averageRating=${averageRating}`

    fetch(url, {
      method: 'GET',
    }).catch(error => {
      console.error('Error:', error)
    })
  }

  trackKlevuLandingClick () {
    const searchTerm = window.klevu.search.landing.getScope().data.context.term
    const klevuResponse = window.klevu?.search?.landing
      ?.getScope()
      ?.data?.response?.current?.queryResults?.filter(
        item => item.id === 'productList',
      )
    const klevuRequest = window.klevu?.search?.landing
      ?.getScope()
      ?.data?.request?.current?.recordQueries?.filter(
        item => item.id === 'productList',
      )

    if (!klevuResponse || !klevuRequest) return

    const klevuPageNumber = window.klevu_currentPageGlobal || 1
    const klevuLimit = window.klevu_productsInitialLimit || 24
    const klevuSort = klevuRequest[0].settings.sort || 'RELEVANCE'
    const klevuTotalResults = klevuResponse[0].meta.noOfResults || ''
    const klevuTypeOfQuery = klevuResponse[0].meta.typeOfSearch || 'AND'
    const klevuSrc = '[[typeOfRecord:KLEVU_PRODUCT;;template:landing]]'

    const klevuApiKey = window.klevu?.settings?.search?.apiKey
    const klevuKeywords = encodeURIComponent(searchTerm)
    const klevuType = 'clicked'
    const klevuProductId = this.variantId
    const klevuProductGroupId = this.productId
    const klevuProductVariantId = this.variantId
    const klevuProductName = encodeURIComponent(this.title)
    const klevuProductUrl = encodeURIComponent(this.productUrl)

    const url = `https://stats.ksearchnet.com/analytics/productTracking?klevu_apiKey=${klevuApiKey}&klevu_keywords=${klevuKeywords}&klevu_type=${klevuType}&klevu_productId=${klevuProductId}&klevu_productGroupId=${klevuProductGroupId}&klevu_productVariantId=${klevuProductVariantId}&klevu_productName=${klevuProductName}&klevu_productUrl=${klevuProductUrl}?klevu_pageNumber=${klevuPageNumber}&klevu_limit=${klevuLimit}&klevu_sort=${klevuSort}&klevu_totalResults=${klevuTotalResults}&klevu_typeOfQuery=${klevuTypeOfQuery}&klevu_src=${klevuSrc}`

    fetch(url, {
      method: 'GET',
    }).catch(error => {
      console.error('Error:', error)
    })
  }

  trackKlevuQuickSearchClick () {
    const searchTerm =
      window.klevu?.search?.quick?.getScope()?.data?.context?.term || ''
    const klevuResponse = window.klevu?.search?.quick
      ?.getScope()
      ?.data?.response?.current?.queryResults?.filter(
        item => item.id === 'productList',
      )

    if (!klevuResponse) return

    const klevuPageNumber = 1
    const klevuLimit = 4
    const klevuSort = 'RELEVANCE'
    const klevuTotalResults = klevuResponse[0].meta.noOfResults || ''
    const klevuTypeOfQuery = klevuResponse[0].meta.typeOfSearch || ''
    const klevuSrc = '[[typeOfRecord:KLEVU_PRODUCT;;template:quick-search]]'

    const klevuApiKey = window.klevu?.settings?.search?.apiKey
    const klevuKeywords = encodeURIComponent(searchTerm)
    const klevuType = 'clicked'
    const klevuProductId = this.variantId
    const klevuProductGroupId = this.productId
    const klevuProductVariantId = this.variantId
    const klevuProductName = encodeURIComponent(this.title)
    const klevuProductUrl = encodeURIComponent(this.productUrl)

    const url = `https://stats.ksearchnet.com/analytics/productTracking?klevu_apiKey=${klevuApiKey}&klevu_keywords=${klevuKeywords}&klevu_type=${klevuType}&klevu_productId=${klevuProductId}&klevu_productGroupId=${klevuProductGroupId}&klevu_productVariantId=${klevuProductVariantId}&klevu_productName=${klevuProductName}&klevu_productUrl=${klevuProductUrl}&klevu_pageNumber=${klevuPageNumber}&klevu_limit=${klevuLimit}&klevu_sort=${klevuSort}&klevu_totalResults=${klevuTotalResults}&klevu_typeOfQuery=${klevuTypeOfQuery}&klevu_src=${klevuSrc}`

    fetch(url, {
      method: 'GET',
    }).catch(error => {
      console.error('Error:', error)
    })
  }

  set labelValue (value) {
    if (!this.labelEl) return
    this.labelEl.textContent =
      value && value.length > 0 ? value : this.initialValue
  }

  get labelValue () {
    return this.labelEl?.textContent || ''
  }

  get selectEl () {
    return this.els?.select?.element
  }

  get labelEl () {
    return this.els?.label?.element
  }

  get buttonEl () {
    return this.els?.button?.element
  }

  get title () {
    return this.querySelector('.ptitle')?.value || ''
  }

  get productId () {
    return this.querySelector('input[name="product_id"]')?.value || ''
  }

  get variantId () {
    return this.querySelector('[name="id"]')?.value || ''
  }

  get productUrl () {
    return this.querySelector('.purl')?.value || ''
  }

  get productPrice () {
    return this.querySelector('.pprice')?.value || ''
  }

  get productSku () {
    return this.querySelector('.psku')?.value || ''
  }

  get recommendationsListId () {
    return this.closest('.klevu-recs')?.getAttribute('id') || ''
  }

  get recommendationsTitle () {
    return this.closest('.kuRECSContainer')?.dataset?.recsTitle || ''
  }

  get recommendationsLogic () {
    return this.closest('.kuRECSContainer')?.dataset?.logic || ''
  }
}

if (!customElements.get('product-card-quickbuy')) {
  customElements.define('product-card-quickbuy', ProductCardQuickBuy)
}
